import React from 'react';
import { Tooltip } from '@trevor/ui-components';
import { StepValue } from '@/views/QueryBuilder/subcomponents/Steps';
import LayerWhere from './LayerWhere';
import { buildClause } from '../../util/helpers/layer-helpers';
import flex from '../../css/module/flex.css';
import StepContent from '../StepContent';
import TableRef from '../../util/TableRef';

export type LayerWhereProps = {
  editLayerClicked: () => void;
  aliases: Record<string, TableRef>;
  isNotClickable: boolean;
  layerIndex: number;
  layer: LayerWhere;
};

export const LayerWhereComponent: React.FC<LayerWhereProps> = ({
  editLayerClicked,
  aliases,
  isNotClickable,
  layerIndex,
  layer,
}) => {
  const clauses = layer.clauses().map(buildClause);
  const clause = buildClause(layer);
  const condition = layer.isAnd() ? 'and' : 'or';

  const style = isNotClickable ? { cursor: 'auto' } : {};
  const layerId = layer.id();

  return (
    <StepContent>
      {/* only show the tooltip in the steps. Not needed elsewhere (i.e. in the dashboard filters) */}
      <>
        <StepValue
          data-tooltip-id={`layer_${layerId}_clause_0`}
          $type="filter"
          onClick={editLayerClicked}
        >
          {clause}
        </StepValue>
        {layerId && (
          <Tooltip id={`layer_${layerId}_clause_0`}>
            {`${aliases?.[layer.lhs().alias()]?.name() ?? ''}.${layer
              .lhs()
              .name()}`}
          </Tooltip>
        )}
      </>
      {clauses.map((c, index) => (
        <span key={index} className={`${flex.alignItemsCenter} ${flex.wrap}`}>
          <span className="margin-right-5">{condition}</span>
          <StepValue
            data-tooltip-id={`layer_${layerIndex}_clause_${index + 1}`}
            $type="filter"
            onClick={editLayerClicked}
            style={style}
          >
            {c}
          </StepValue>
          {layerIndex && (
            <Tooltip id={`layer_${layerIndex}_clause_${index + 1}`}>
              {`${
                aliases?.[layer.clauses()[index].lhs().alias()]?.name() ?? ''
              }.${layer.clauses()[index].lhs().name()}`}
            </Tooltip>
          )}
        </span>
      ))}
    </StepContent>
  );
};

export default LayerWhereComponent;
